export default __webpack_public_path__ + "static/media/english.039fc4e4.png";